import { useTranslation } from 'react-i18next';
import { UseFormRegister, Path } from 'react-hook-form';
import type { SaveCompanyDto } from '@monorepo/shared';
import { FormCheckbox } from '../ui/FormCheckbox';

interface FacilitiesFormProps<T extends SaveCompanyDto> {
  register: UseFormRegister<T>;
}

export const FacilitiesForm = <T extends SaveCompanyDto>({ register }: FacilitiesFormProps<T>) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold text-text border-b pb-2">
        {t('company.section.facilities')}
      </h2>

      <p className="text-sm text-secondary">{t('company.section.facilities_subtitle')}</p>

      <FormCheckbox
        label={t('company.has_video_surveillance.label')}
        {...register('hasVideoSurveillance' as Path<T>)}
      />

      <FormCheckbox
        label={t('company.has_video_protection.label')}
        {...register('hasVideoProtection' as Path<T>)}
      />

      <FormCheckbox
        label={t('company.records_phone_calls.label')}
        {...register('recordsPhoneCalls' as Path<T>)}
      />

      <FormCheckbox
        label={t('company.has_works_council.label')}
        {...register('hasWorksCouncil' as Path<T>)}
      />

      <FormCheckbox
        label={t('company.has_legal_department.label')}
        {...register('hasLegalDepartment' as Path<T>)}
      />

      <FormCheckbox
        label={t('company.has_it_department.label')}
        {...register('hasItDepartment' as Path<T>)}
      />
    </div>
  );
};
